module.exports = __webpack_public_path__ + "static/img/applestorewht.5e17c7f5.png";